$(document).on('click', '[data-trigger="notify"]', function(e){
  e.preventDefault();
  var trigger = $(this);
  if ($('[data-back-in-stoc-notification-form]').length) {
      const productId = $(this).attr('data-product-id');
      const variantId = $(this).attr('data-variant-id');
      const productTitle = $(this).find('[data-product-title]').text();
      const variantTitle = $(this).find('[data-variant-title]').text();
      const formData = new FormData(document.querySelector('[data-back-in-stoc-notification-form]'));
      formData.append('product_id', productId);
      formData.append('variant_id', variantId);
      formData.append('product_title', productTitle);
      formData.append('variant_title', variantTitle);

      // Send the form data using AJAX
      $.ajax({
          type: 'POST',
          url: '/apps/esselle-retails/back-in-stock/notify',
          crossDomain: true,
          cache: false,
          data: formData,
          processData: false,
          contentType: false,
          dataType: "json",
          beforeSend: function() {
              $('[data-bis-popup]').remove();
              trigger.find('span.loader').removeClass('hidden');
              trigger.find('span.text').addClass('hidden');
          },
          success: function(response) {
              var msg = response?.message ? response.message : 'Thank you! You will be notified when the product is back in stock.';
              var popup = `<div data-bis-popup class="bis-popup" style="position: fixed;left: 0;top: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 96513;"><div class="content" style="width: max-content;max-width: 500px;padding: 30px;background: #fff;margin-left: 10px;margin-right: 10px;text-align: center;position: relative;"><span data-bis-popup-close="" style="position: absolute;right: 0;top: 0;line-height: 1;padding: 10px;font-weight: bold;cursor: pointer;">✕</span>${msg}</div><style>.bis-popup::after {content: "";position: absolute;left: 0;width: 100%;top: 0;height: 100%;background: rgba(0,0,0,0.5);z-index: -1;}</style></div>`;
              $('body').append(popup);
          },
          error: function(xhr, status, error) {
              console.error("Back in stock error", xhr, status, error);
          },
          complete: function() {
              trigger.find('span.loader').addClass('hidden');
              trigger.find('span.text').removeClass('hidden');
          }
      });
  }
})
$(document).on('click', '[data-bis-popup-close]', function(e){
  $('[data-bis-popup]').remove();
});